import { kea } from 'kea'
import controller from './controller.rb'
import { put } from '@redux-saga/core/effects'
import PropTypes from 'prop-types'

export default kea({
  initScene: {
    scene: 'faqs',

    reload: () => controller.index({}),

    transform: payload => ({
      faqsTeachers: payload.faqsTeachers,
      faqsStudents: payload.faqsStudents,
      questionType: payload.questionType,
      questionTypes: payload.questionTypes,
      helpString: payload.helpString
    })
  },
  path: () => ['scenes', 'faqs', 'index'],

  actions: () => ({
    setSearchInput: search => ({ search }),
    setQuestionTypeParam: questionType => ({ questionType }),
    updateQuestionType: questionType => ({ questionType }),
    submitQuestion: true,
    resetUrl: true,
    setFaqParam: slug => ({ slug }),
    setFaqs: faqs => ({ faqs }),
    setNotFoundKeyword: inputValue => ({ inputValue }),
    hideQuestion: true,
    setUrlQuery: searchedValue => ({ searchedValue })
  }),

  actionToUrl: ({ actions, values }) => ({
    [actions.setQuestionTypeParam]: () => `/${values.helpString}/${values.questionTypeSlug}`,
    [actions.setUrlQuery]: ({ searchedValue }) => `/${values.helpString}/${values.questionTypeSlug}#${searchedValue}`,
    [actions.setFaqParam]: () => `/${values.helpString}/${values.questionTypeSlug}/${values.slug}`,
    [actions.resetUrl]: () => `/${values.helpString}`
  }),

  urlToAction: ({ actions, values }) => ({
    '/:helpString/:questionTypeSlug/:slug': ({ questionTypeSlug, slug }) => {
      if (
        values.questionTypes.for_teachers !== questionTypeSlug &&
        values.questionTypes.for_students !== questionTypeSlug
      ) {
        actions.resetUrl()
      } else if (slug && questionTypeSlug) {
        let questionType = values.questionTypes.for_teachers === questionTypeSlug ? 'for_teachers' : 'for_students'
        actions.updateQuestionType(questionType)
        actions.setFaqParam(slug)
      }
    },
    '/:helpString/:questionTypeSlug': ({ questionTypeSlug }) => {
      if (
        values.questionTypes.for_teachers !== questionTypeSlug &&
        values.questionTypes.for_students !== questionTypeSlug
      ) {
        actions.resetUrl()
      } else {
        let questionType = values.questionTypes.for_teachers === questionTypeSlug ? 'for_teachers' : 'for_students'
        const hasSearchQuery = typeof window !== 'undefined' && window && window.location.href.includes('#')

        if (values.searchedFaqs && hasSearchQuery) {
          actions.setFaqs(values.searchedFaqs)
          actions.hideQuestion()
        } else {
          actions.setQuestionTypeParam(questionType)

          if (!hasSearchQuery) {
            actions.setSearchInput('')
          }
        }
      }
    },
    '/:helpString': () => {
      actions.setQuestionTypeParam('for_students')
    }
  }),
  reducers: ({ actions, values }) => ({
    faqsStudents: [null, {}],
    faqsTeachers: [null, {}],
    questionTypes: [null, PropTypes.object, {}],
    faqsResult: [
      null,
      {
        [actions.setFaqs]: (state, payload) => payload.faqs,
        [actions.setQuestionTypeParam]: () => null
      }
    ],
    questionType: [
      'for_students',
      PropTypes.string,
      {
        [actions.setQuestionTypeParam]: (state, payload) => payload.questionType,
        [actions.updateQuestionType]: (state, payload) => payload.questionType
      }
    ],

    helpString: [null, PropTypes.string, {}],
    searchInput: [
      '',
      PropTypes.string,
      {
        [actions.setSearchInput]: (state, payload) => payload.search
      }
    ],
    slug: [
      null,
      {
        [actions.setFaqParam]: (state, payload) => payload.slug,
        [actions.setQuestionTypeParam]: () => null,
        [actions.hideQuestion]: () => null
      }
    ],
    notFoundKeyword: [
      '',
      {
        [actions.setNotFoundKeyword]: (state, payload) => payload.inputValue
      }
    ],
    searchedFaqs: [
      null,
      {
        [actions.setFaqs]: (_, { faqs }) => faqs,
        [actions.setQuestionTypeParam]: () => null
      }
    ]
  }),
  selectors: ({ selectors }) => ({
    faqs: [
      () => [selectors.faqsStudents, selectors.faqsTeachers, selectors.questionType, selectors.faqsResult],
      (faqsStudents, faqsTeachers, questionType, faqsResult) => {
        if (faqsResult) {
          return faqsResult
        } else if (questionType === 'for_students') {
          return faqsStudents
        } else if (questionType === 'for_teachers') {
          return faqsTeachers
        } else {
          return []
        }
      }
    ],

    faq: [
      () => [selectors.faqs, selectors.slug, selectors.questionType],
      (faqs, slug, questionType) => {
        if (slug) {
          return faqs.filter(
            faq => (faq.questionType === questionType || faq.questionType === 'for_both') && faq.slug === slug
          )[0]
        } else {
          return null
        }
      }
    ],
    questionTypeSlug: [
      () => [selectors.questionType, selectors.questionTypes],
      (questionType, questionTypes) => {
        if (questionType === 'for_teachers') {
          return questionTypes.for_teachers
        }

        return questionTypes.for_students
      }
    ]
  }),
  takeLatest: ({ actions, values }) => ({
    [actions.submitQuestion]: function * () {
      const { searchInput, questionType } = values
      const { setFaqs, setNotFoundKeyword, resetUrl, setUrlQuery } = actions
      const response = yield controller.search({ search: searchInput, question_type: questionType })

      if (response.error) {
        yield put(resetUrl())
      } else {
        yield put(setUrlQuery(searchInput))
        yield put(setFaqs(response.faqs))
        yield put(setNotFoundKeyword(searchInput))
      }
    },
    [actions.setFaqParam]: function * () {
      const { slug } = values
      const { resetUrl } = actions
      const response = yield controller.updateFaqViewed({ slug })

      if (response.error) {
        yield put(resetUrl())
      }
    }
  })
})
